export const LOGIN_FORM_EMAIL = 'email';
export const LOGIN_FORM_PASSWORD = 'password';

export const LOGIN_TEST_ID = 'login-form';

export enum ERROR_TYPE {
  GENERAL = 'general',
  LOGIN = 'login',
}
